import { render, staticRenderFns } from "./TransferProductPiecesList.vue?vue&type=template&id=64b92427&"
import script from "./TransferProductPiecesList.vue?vue&type=script&lang=js&"
export * from "./TransferProductPiecesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports